module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("A Detective from Small Town America")]), _vm._v(" "), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#grandma-on-the-run"
    }
  }, [_vm._v("Grandma on the Run")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#good-movie-whos-watching-who"
    }
  }, [_vm._v("Good Movie! Who’s Watching Who?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#guess-whos-coming-to-dinner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Guess Who’s Coming to dinner")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#hat-trick",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hat Trick")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#suspicious-person",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suspicious Person")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#jeffrey-j-frank-l.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jeffrey J (Frank L.)")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#is-there-a-doctor-in-the-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Is There A Doctor In The House?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#cedar-avenue-coin-collector",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cedar Avenue Coin Collector")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#man-shoots-at-gabe",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Man Shoots at Gabe")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#dart-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dart Man")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#im-not-in-here",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I’m Not in Here")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#are-you-ready-to-catch-some-fish",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Are You Ready to Catch Some Fish?")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#lake-street",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lake Street")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0